import { useSelector } from 'react-redux';

import { getCurrentUser } from 'src/selectors/userSelectors';

export const useIsNewInvoicingFlow = () => {
  const currentUser = useSelector(getCurrentUser);

  return currentUser.isPsychiatrist;
};
